import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../libraries';

@BindAll()
export class ShopController {
  /** 获取重定向地址 */
  async getReturnUrl(body) {
    return await AjaxBasics.request({
      ...EnumAPI.live_mudu_getGoodsUrl,
      body,
    });
  }
}
